import React from 'react';
import { Box, Text } from '@chakra-ui/core';
import { Cell } from 'react-table';
import colors from '../../../styles/colors';
import { CandidateSearchResponseType } from '../CandidateSearchTypes';

interface FullNameCellProps {
  cell: Cell<CandidateSearchResponseType>;
  onCandidateModalOpen: (candidateId: string) => void;
}

export const FullNameCell: React.FC<FullNameCellProps> = ({ cell, onCandidateModalOpen }) => {
  const { fullName, email, id } = cell.row.original;
  return (
    <Box
      className={cell.column.id}
      data-testid={cell.column.id}
      py="10px"
      onClick={/* istanbul ignore next */ () => onCandidateModalOpen(id)}
      cursor="pointer"
      width="100%"
    >
      <Box as="span" style={{ color: colors.linkBlue, textDecoration: 'underline' }} fontSize="15px" fontWeight={400}>
        {fullName}
      </Box>
      <Text fontSize="12px" fontWeight={400} whiteSpace="normal" wordBreak="break-word">
        {email}
      </Text>
    </Box>
  );
};
